import React from 'react';
import FlyoutSwitch, {FORECASTING_FLYOUT_MODE} from '../common/FlyoutSwitch';

const FlyoutNotionalPools = () => {
	return <FlyoutSwitch startMode={FORECASTING_FLYOUT_MODE.NOTIONAL_POOLS_LIST} />;
};

export default FlyoutNotionalPools;
